export function externalMapsUrl(location) {
  const value = String(location || "").trim();
  if (!value) return null;
  if (/^https?:\/\//i.test(value)) return value;

  const query = encodeURIComponent(value);
  if (typeof navigator !== "undefined") {
    const ua = navigator.userAgent || "";
    if (/Android/i.test(ua)) {
      return `geo:0,0?q=${query}`;
    }
    if (/iPhone|iPad|iPod/i.test(ua)) {
      return `https://maps.apple.com/?q=${query}`;
    }
  }
  return `https://www.google.com/maps/search/?api=1&query=${query}`;
}
